"use client";
import React, { useEffect, useState } from 'react';
import Link from "next/link";
import forget from "./reset.module.css";
import { useRouter } from 'next/navigation';
import tohash from '../utils/tohash';
import validator from '../utils/validator';
import { fetchWithLoader } from '../utils/api';
import { useAuthStore } from '../store/authstore';
import { useToastStore } from '../store/localapi';



export default function Forget() {
  const router = useRouter();
  const validate = validator();
  const user = useAuthStore(state=>state.user)
  const { showToast} = useToastStore();
  const [email, setEmail] = useState<string>('');
  const [error, setError] = useState<string>('');

    useEffect(()=>{
      if(user && user.user_id){
        router.replace('/')
      }
    },[user,router])
    

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!email) {
      setError('Email is required');
      return;
    }
    fetchWithLoader('drama_forgotpass.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ user_email: email }),
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        setEmail('');
        setError('');
        if (data?.data?.ErrorCode === -1) {
          showToast("Email Id doesn't exist","info")
          setError(data?.data?.ErrorMessage || 'Failed to send password reset link. Please try again later.');
          // setTimeout(() => {
          //   router.push(`/signup?forget=${email}`); 
          // }, 1000);
          return;
        }
        if (data?.data?.data?.Otp!=="") {
          showToast("OTP sent to your email","success")
          const hash = tohash(data?.data?.data?.Otp.toString());
          const final = `${hash?.slice(0,5)}${data?.data?.data?.Otp}${hash?.slice(5)}`;
          sessionStorage.setItem('_hash', `${final}`);
          router.push(`/verifyotp?forget=${email}`);
          return;
        }
      })
      .catch(error => {
        console.error('Error sending password reset OTP:', error);
        showToast("Failed to send password reset OTP. Please try again later.","error")
        setError('Failed to send password reset OTP. Please try again later.');
      });
  };

  return (
    
      <div className={`${forget.signupforget} signUpSec`}>
        <div className="container">
          <div className="signupForm">
            <form onSubmit={handleSubmit} className={forget.forgetForm}>
              <div className="titcenter">
                <h2 className={`${forget.forgethead} heaing`}>Forgot Your Password?</h2>
                <p className={`${forget.forgettext} register`}>We&#39;ll send you a link to reset it.</p>
              </div>
              <div className="field">
                <div className="email">
                  <input type="email" 
                  value={email}
                  onChange={(e)=>setEmail(e.target.value)}
                  onBlur={()=>setError(validate.email(email) ?? '')}
                  name="Email" id="email" placeholder='Email*' autoComplete="email" required />

                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                      <path d="M18.3104 6.379C18.5757 7.36621 18.5757 8.72811 18.5757 10.8299C18.5757 13.8152 18.5757 15.3079 17.8154 16.3542C17.5699 16.6922 17.2727 16.9894 16.9348 17.2349C15.8884 17.9952 14.3957 17.9952 11.4104 17.9952H9.81808C6.83278 17.9952 5.34008 17.9952 4.29371 17.2349C3.95575 16.9894 3.65855 16.6922 3.41301 16.3542C2.65278 15.3079 2.65277 13.8152 2.65277 10.8299C2.65277 8.72111 2.65277 7.35713 2.92076 6.36914L4.59481 8.04325C5.89436 9.34278 6.91279 10.3612 7.81419 11.049C8.73684 11.7529 9.60687 12.1665 10.6143 12.1665C11.6218 12.1665 12.4918 11.7529 13.4145 11.049C14.3159 10.3612 15.3343 9.34278 16.6339 8.04324L18.1905 6.48663L18.3104 6.379Z" fill="#9B9D9C" />
                      <path d="M17.7793 5.25635L17.6926 5.32806L17.3686 5.61888L15.8215 7.166C14.4826 8.50484 13.5201 9.4656 12.6898 10.099C11.8734 10.722 11.2555 10.9718 10.6141 10.9718C9.97269 10.9718 9.3548 10.722 8.53836 10.099C7.70814 9.4656 6.7456 8.50484 5.40672 7.166L3.56929 5.32856L3.4693 5.22912C3.71483 4.89118 3.9555 4.66984 4.29347 4.42431C5.33984 3.66406 6.83254 3.66406 9.81784 3.66406H11.4101C14.3955 3.66406 15.8881 3.66406 16.9345 4.42431C17.2725 4.66984 17.5338 4.91841 17.7793 5.25635Z" fill="#9B9D9C" />
                    </svg>
                  </span>

                </div>
                <p className="error" style={{opacity:error ? 1 : 0}}>{error}</p>
              </div>
              <div className={`${forget.loginbtnforgt} loginBtn`}>
                <button type='submit' value='' className="commonBtn">Send</button>
                <p className='signupLnk'>Back to <Link href="login">Sign In</Link></p>
              </div>
            </form>
          </div>
        </div>
      </div>
    
  )
}
